export const GoogleMapApiConfig = 'AIzaSyDsggR9rpIA2QNWsAn8OWEo9Jy3-iiauA0';